import src from "IMAGE";
export default { src, width: 60, height: 64, blurWidth: 0, blurHeight: 0};
